import { render, staticRenderFns } from "./inventory-input.vue?vue&type=template&id=c505a35e&"
import script from "./inventory-input.vue?vue&type=script&lang=js&"
export * from "./inventory-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports